import React, { useEffect, useRef } from 'react';

/**
 * The outcome of "Don't ask for a code on this computer for 30 days"
 * (v3.91.0, utils/trustedComputer.js), shown after the sign-in it followed.
 * The trust step runs in the background after the code screen has closed, so
 * its result needs a place of its own. A success fades by itself; a failure
 * ('error') or something to act on ('warn') stays until dismissed.
 */
export const OK_NOTICE_MS = 12000;

function TrustedComputerNotice({ notice, onDismiss }) {
  const ok = notice && notice.tone === 'ok';
  const warn = notice && notice.tone === 'warn';
  // The parent passes a new callback on every render; the timer must not restart with it.
  const dismissRef = useRef(onDismiss);
  dismissRef.current = onDismiss;

  useEffect(() => {
    if (!ok) return undefined;
    const t = setTimeout(() => dismissRef.current && dismissRef.current(), OK_NOTICE_MS);
    return () => clearTimeout(t);
  }, [ok, notice]);

  if (!notice || !notice.text) return null;

  return (
    <div
      className="trusted-computer-notice"
      role={ok ? 'status' : 'alert'}
      style={{
        position: 'fixed', left: '50%', bottom: '20px', transform: 'translateX(-50%)', zIndex: 9998,
        width: 'min(560px, calc(100vw - 32px))', boxSizing: 'border-box',
        display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 10px 10px 16px',
        borderRadius: '10px', boxShadow: '0 4px 14px rgba(0,0,0,0.15)',
        background: ok ? '#ecfdf5' : (warn ? '#fffbeb' : '#fef2f2'),
        color: ok ? '#065f46' : (warn ? '#92400e' : '#991b1b'),
        border: `1px solid ${ok ? '#a7f3d0' : (warn ? '#fde68a' : '#fecaca')}`, fontSize: '0.9em',
      }}
    >
      <span style={{ flex: 1 }}>{notice.text}</span>
      <button
        type="button"
        onClick={onDismiss}
        style={{ minHeight: '44px', minWidth: '44px', padding: '0 12px', background: 'none', border: 'none', color: 'inherit', fontWeight: 600, cursor: 'pointer' }}
      >
        Dismiss
      </button>
    </div>
  );
}

export default TrustedComputerNotice;
